import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const OptionsWrapper = Styled.article`
display: inline-block;
background-color: ${color.white};
border-radius: 4px;
overflow: hidden;
`;

const Option = Styled.span`
position: relative;    
`;

const CheckBox = Styled.input.attrs(({ id }) => ({
  type: 'checkbox',
  id: id,
  name: 'options',
}))`
position: absolute;
top:0;
left:0;
width: 100%;
height: 100%;
cursor: pointer;
opacity: 0;
&:hover ~ *{background-color: ${color.lightAlt}}
&:checked ~ *{background-color: ${color.secondaryAlt}}
`;

const OptionValue = Styled.span`
padding: 1rem 3.5rem;
display: inline-block;
background: ${color.white};
text-transform: capitalize;
border: none;
&:not(:first-child){border-left: solid 1px ${color.lightAlt};}};
`;

const Label = Styled.label`display: block; color: ${color.primary};`;

const SelectField = (props) => {
  const { options, onSelect, label, id } = props;
  return (
    <div>
      <Label htmlFor={label}>{label}</Label>
      <OptionsWrapper>
        {options.map(({ label, value }) => (
          <Option key={label}>
            <CheckBox
              id={id}
              value={value}
              data-id={label}
              onClick={onSelect}
            />
            <OptionValue>{value}</OptionValue>
          </Option>
        ))}
      </OptionsWrapper>
    </div>
  );
};

export default SelectField;
